module.exports = __webpack_public_path__ + "img/c26.6d98c20e.svg";